import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialog} from "@angular/material/dialog";
import { PowerSupplyService} from "@psnb/services";
import { ValidationErrorDialog } from "../../Upload/power-supply-bulk-upload/validation-error-dialog";

@Component({
  selector: 'nwt-power-supply-delete-card-type-dialog',
  template:
    `
  <h1 mat-dialog-title>Are you Sure you want to Delete this ?</h1>
  <mat-dialog-actions class="d-flex justify-content-center">
    <button mat-button type="button" (click)="dialogRef.close()">No Thanks</button>
    <button mat-button (click)="delete()">Delete</button>
  </mat-dialog-actions>
  <mat-error *ngIf="error" class="d-flex justify-content-center">
  <strong>Unable to Delete Controller Card Type. Please try later !! </strong>
  </mat-error>
  `
})
export class WorkItemDeleteDialogComponent implements OnInit {

  error: boolean = false;
  private validationErrorDialog: MatDialogRef<ValidationErrorDialog>;
  constructor( private dialog: MatDialog,
    public dialogRef: MatDialogRef<WorkItemDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private powerSupplyService: PowerSupplyService,) {

  }

  ngOnInit() {
  }

  delete() {
    if(this.data.permissionValue == true) {
      if (this.data.id !== null || this.data.id !== undefined) {
        this.powerSupplyService.deleteControllerWorkItem(this.data.id).subscribe(result => {
          if (result.success === true) {
            this.dialogRef.close(result.success);
            let errMessage = "Work Item Deleted Successfully";
            this.openDialog(errMessage);
          }
           else this.error = true;
        })
      }
    } else {
      if (this.data.id !== null || this.data.id !== undefined) {
        this.powerSupplyService.deleteTriageWorkItem(this.data.id).subscribe(result => {
          if (result.success === true) {
            this.dialogRef.close(result.success);
            let errMessage = "Work Item Deleted Successfully";
            this.openDialog(errMessage);
          }
           else this.error = true;
        })
      }
    }
  }
   openDialog(message: string) {
    this.validationErrorDialog = this.dialog.open(ValidationErrorDialog, {
      data: {
        message: message ? message : ''
      },
      disableClose: true
    })
    this.validationErrorDialog.afterClosed().subscribe(() => { });
  }
}
